








import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
    metaInfo() {
        return {
            title: '準備中',
        }
    }
})
export default class Preparing extends Vue {
}
